import { render, staticRenderFns } from "./staff_profile.vue?vue&type=template&id=2c1e01f9"
import script from "./staff_profile.vue?vue&type=script&lang=js"
export * from "./staff_profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports